/**
 * BrowsePreview — landing-page "peek inside" widget.
 *
 * Small browser-frame chrome that plays a real, muted, auto-looping screen
 * recording of the actual /browse page. Sits inline next to the hero logo on
 * desktop and stacks below on mobile.
 *
 * The video is a static asset served from /media/browse-preview.mp4 so we
 * don't depend on any external CDN at load time.
 */
import { Link } from "react-router-dom";

const VIDEO_SRC = "/media/browse-preview.mp4";

export default function BrowsePreview() {
  return (
    <div
      className="relative border border-white/10 bg-[#0E0E10] shadow-[0_25px_60px_-15px_rgba(255,95,31,0.25)] overflow-hidden select-none"
      data-testid="landing-browse-preview"
    >
      {/* Fake browser bar */}
      <div className="flex items-center gap-2 px-3 py-1.5 border-b border-white/10 bg-[#141416]">
        <div className="flex gap-1">
          <span className="w-2 h-2 rounded-full bg-red-500/70" />
          <span className="w-2 h-2 rounded-full bg-yellow-500/70" />
          <span className="w-2 h-2 rounded-full bg-emerald-500/70" />
        </div>
        <div className="flex-1 mx-2">
          <div className="h-4 bg-[#0A0A0A] border border-white/5 flex items-center px-2 font-mono text-[8px] text-zinc-500 tracking-widest">
            🔒 hunt57.com/browse
          </div>
        </div>
        <span className="font-mono text-[8px] uppercase tracking-widest text-emerald-400">● LIVE</span>
      </div>

      {/* Looping screen recording of the real Browse page.
          aspect-[3/2] gives the frame extra height (per user request) while
          `object-contain` guarantees the FULL page — including the left
          filter sidebar — stays visible with dark letterboxing above/below. */}
      <div className="relative bg-black aspect-[3/2] overflow-hidden">
        <video
          src={VIDEO_SRC}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          aria-label="Preview of the Hunt57 Browse page"
          data-testid="landing-browse-preview-video"
          className="absolute inset-0 w-full h-full object-contain"
        />

        {/* Bottom fade + Sign-up CTA */}
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/85 to-transparent pointer-events-none" />
        <Link
          to="/register"
          data-testid="preview-cta-signup"
          className="absolute inset-x-2 bottom-2 h57-btn-primary text-[10px] !py-1.5 !px-2 text-center block"
        >
          Sign Up Free to See More →
        </Link>
      </div>
    </div>
  );
}
